export const PASS_TYPE_DISPATCH = 'Dispatch'

export const isDispatchPass = ({ typeO, statusDispatchPass, movement, flag } = {}) =>
  typeO === PASS_TYPE_DISPATCH ||
  flag === 'dispatch_pass' ||
  Boolean(statusDispatchPass) ||
  movement === 'Pase de salida'

export const resolvePassTypeO = (options = {}) =>
  isDispatchPass(options) ? PASS_TYPE_DISPATCH : ''

export const passModuleTitle = (isDispatch) =>
  `Formulario de ${isDispatch ? 'Despacho' : 'Entradas'} de Mercancía en Zonas Francas`

export const passEditModuleTitle = (isDispatch) =>
  `Edición de formulario de ${isDispatch ? 'Despacho' : 'Entradas'} de Mercancía en Zonas Francas`
